import useVariations from '../../../../../data/variations'
import { useState } from 'react'
import { AiVariationContextWithRefresh } from './aiVariationTypes'

export const useManageAiVariationsButton = (
	props: AiVariationContextWithRefresh & { askToSaveFirst: boolean | undefined },
) => {
	const [modalVisible, setModalVisible] = useState(false)

	const showModal = () => {
		if (props.askToSaveFirst) {
			return
		}
		setModalVisible(true)
	}

	const { mutate } = useVariations(props.campaignId || -1, true)

	const hideModal = (refreshParentArticle: boolean = false) => {
		setModalVisible(false)
		if (refreshParentArticle && mutate) {
			mutate()
		}
	}

	return {
		modalVisible,
		showModal,
		hideModal,
	}
}
